export default "__VITE_ASSET__0DwvY8FE__"